import { render } from "./linkButton.vue?vue&type=template&id=52794d90&scoped=true"
import script from "./linkButton.vue?vue&type=script&lang=js"
export * from "./linkButton.vue?vue&type=script&lang=js"

import "./linkButton.vue?vue&type=style&index=0&id=52794d90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52794d90"]])

export default __exports__